import { ProductRepublishEvent } from '../../Shared/events';
import { ProductRepublishBIModel } from '../models';
import { track } from '../../tracking/bi-track';

export const productRepublishBIEventListener = () => {
    document.addEventListener( ProductRepublishEvent.eventType, (productRepublishEvent) => {
        const productRepublishBIModel = ProductRepublishBIModel.createFromDomainEvent(productRepublishEvent);
        track(productRepublishBIModel);
    } );
};
